import React from 'react';
import {
    WarningModal,
    CertificateModal,
    CertificateModalProps,
    IEmptySectionProps,
    CertificateTab,
} from 'components';
import { IExpertCertificate } from 'components/models';
import { Button } from 'react-bootstrap';
import { IApiError } from '_helpers/ApiConnector/types';
import expertIcon from 'components/assets/svg/empty_expert_table.svg';
import moment from 'moment';
import cn from 'classnames';

const Certificate = ({
    onCreate,
    onDelete,
    onChange,
    onSuccess,
    certificateList,
    onlyWatch,
    withoutCardHeader,
    onlyChange,
    apiError,
    withBorder,
    onlyOneCertificate,
}: IProps) => {
    const state: IState = {
        showModal: false,
        showWarning: false,
        certificate: null,
    };

    const [showModal, setShowModal] = React.useState(state.showModal);
    const [showWarning, setShowWarning] = React.useState(state.showWarning);
    const [certificate, setCertificate] = React.useState(state.certificate);

    const emptyDataProps: IEmptySectionProps = {
        placeholderTitle: 'Нет свидетельств члена комиссии',
        placeholderText: !onlyWatch ? 'Вам необходимо добавить свидетельство члена комиссии' : '',
        placeholderButtonText: !onlyWatch ? 'Добавить свидетельство' : '',
        placeholderIcon: expertIcon,
        onButtonClick: () => {
            if (!onlyWatch) {
                setShowModal(true);
            }
        },
    };

    const modalDataProps: CertificateModalProps = {
        onHide: () => { setShowModal(false); setCertificate(null); },
        onSubmit: async (certificateData: ICertificateData) => {
            let res = true;

            if (certificate && certificate.id && onChange) {
                res = await onChange(certificate.id, certificateData);
            } else if (onCreate) {
                res = await onCreate(certificateData);
            }

            if (res) {
                setShowModal(false);
                setCertificate(null);
            }

            return res;
        },
        title: certificate ? 'Свидетельство члена комиссии' : 'Добавление свидетельства члена комиссии',
        show: showModal,
        onDelete: () => setShowWarning(true),
        onSuccess,
        certificate,
        apiError,
    };

    const onAddCertificate = () => {
        setShowModal(true);
        setCertificate(null);
    };

    const onDeleteCertificate = () => {
        if (certificate && onDelete) {
            onDelete(certificate.id);
            setShowModal(false);
            setCertificate(null);
        }
        setShowWarning(false);
    };

    const onChangeCertificate = (data: IExpertCertificate) => {
        setCertificate(data);
        setShowModal(true);
    };

    const onHeaderButtonClick = () => {
        if (onlyWatch || onlyChange) return;

        if (onlyOneCertificate && certificateList && certificateList[0]) {
            onChangeCertificate(certificateList[0]);
        } else {
            onAddCertificate();
        }
    };

    const renderHeaderButton = () => (!onlyWatch && !onlyChange && (onlyOneCertificate ? (certificateList && certificateList[0]) : true) ? (
        <Button onClick={onHeaderButtonClick}>
            {onlyOneCertificate ? 'Редактировать' : 'Добавить свидетельство'}
        </Button>
    ) : null);

    return (
        <>
            <CertificateTab
              cardTitle={!withoutCardHeader ? 'Свидетельство члена комиссии' : undefined}
              cardCategory={!withoutCardHeader ? 'Информация о свидетельстве члена комиссии' : undefined}
              cardClassName={cn(!withBorder && 'border-0')}
              cardContentClassName={withoutCardHeader ? 'pt-0' : undefined}
              certificateList={certificateList && certificateList[0] ? [certificateList[0]] : null}
              renderHeaderButton={renderHeaderButton}
              apiError={null}
              {...emptyDataProps}
            />
            <WarningModal
              title="Удалить свидетельство?"
              show={showWarning}
              onHide={() => setShowWarning(false)}
              onAccess={onDeleteCertificate}
            />
            <CertificateModal {...modalDataProps} />
        </>
    );
};

export default Certificate;

interface IState {
    showModal: boolean;
    showWarning: boolean;
    certificate: IExpertCertificate | null;
}

export interface IProps {
    apiError: IApiError | null;
    certificateList: IExpertCertificate[] | null;
    onlyWatch?: boolean;
    onlyChange?: boolean;
    onlyOneCertificate?: boolean;
    withoutCardHeader?: boolean;
    withBorder?: boolean;
    onCreate?: (certificateData: ICertificateData) => Promise<boolean>;
    onDelete?: (certificateId: string) => void;
    onChange?: (certificateId: string, certificateData: ICertificateData) => Promise<boolean>;
    onSuccess?: () => void;
}

export interface ICertificateData {
    id?: string;
    regNumber: string;
    issueDate: moment.Moment;
    expireDate: moment.Moment;
    file?: File;
}
